import { render, staticRenderFns } from "./ManageBranch.vue?vue&type=template&id=85644fa4&scoped=true&"
import script from "./ManageBranch.vue?vue&type=script&lang=js&"
export * from "./ManageBranch.vue?vue&type=script&lang=js&"
import style0 from "./ManageBranch.vue?vue&type=style&index=0&id=85644fa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85644fa4",
  null
  
)

export default component.exports